<template>
    <content-layout>
        <template #header>Banner Images</template>
        <template #description>The large image at the top of these website pages.</template>

        <el-form ref="form" label-position="top">
            <el-form-item v-for="bannerImage in bannerImages" :key="bannerImage.pageName" :label="pageLabel(bannerImage.pageName)">
                <image-upload :image="bannerImage.fileName" @upload="fileName => onUploaded(bannerImage, fileName)" @delete="onDeleted(bannerImage)" />
            </el-form-item>
        </el-form>
    </content-layout>
</template>

<script>
    import ImageUpload from "../components/ImageUpload";

    export default {
        name: "BannerImages",
        components: {ImageUpload},
        data() {
            return {
                bannerImages: [],
                headers: {Authorization: localStorage.getItem('Authorization')},
                baseUrl: process.env.VUE_APP_ROOT_API,
            }
        },
        methods: {
            // Where each banner shows on the website (the DB names are older than the pages).
            pageLabel(pageName) {
                const labels = {
                    guide: 'Guide page (lavishlocations.com/guide)',
                    about: 'Ask an Expert page (lavishlocations.com/askanexpert)',
                    register: 'Register page (not currently used on the website)',
                };
                return labels[pageName] || pageName.charAt(0).toUpperCase() + pageName.slice(1) + ' page';
            },


            async onDeleted(bannerImage) {
                const response = await this.axios.patch(this.baseUrl + '/api/bannerImage/' + bannerImage._id, {fileName: ''},{headers: this.headers});
                console.log('patch response', response);
                await this.getBannerImages();
            },

            async onUploaded(bannerImage, fileName) {
               const response = await this.axios.patch(this.baseUrl + '/api/bannerImage/' + bannerImage._id, {fileName: fileName},{headers: this.headers});
                console.log('patch response', response);
                await this.getBannerImages();
            },

            async getBannerImages() {
                const response = await this.axios.get(this.baseUrl + '/api/bannerImage', {headers: this.headers});
                this.bannerImages = response.data;
            }
        },

        async created() {
            await this.getBannerImages();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/site-content/BannerImages.vue